import React from "react";
import aboutBg from "../assets/kitchen.jpg"; // Add a background image for consistency

const AboutUs: React.FC = () => {
  return (
    <section id="about-us" className="relative">
      {/* Title Section */}
      <div className="bg-gray-100">
        <div className="container mx-auto px-4"></div>
      </div>

      {/* Main Section with Background */}
      <div
        className="relative bg-cover bg-center bg-no-repeat flex items-center justify-center text-white py-10 px-6"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, .5) 60%, rgba(0, 0, 0, 0) 75%, transparent 80%), url(${aboutBg})`,
          backgroundPosition: "right center",
          backgroundSize: "cover",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#1E3A8A] to-transparent opacity-50 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-gradient-to-tl from-[#1E3A8A] to-transparent opacity-50 rounded-full blur-3xl"></div>

        {/* Content */}
        <div className="relative max-w-4xl mx-auto text-center space-y-8">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-[#1E3A8A]">
            About Us
          </h1>
          <p className="text-md md:text-lg mb-8 leading-relaxed">
            I'm John Hayden, owner of Hayden Home Services. My team and I are
            focused on one thing: delivering quality home services at a fair
            price, with integrity behind every job. From small repairs to
            major home improvements, we take pride in delivering top-notch
            workmanship with a personal touch.
          </p>
          <p className="text-md md:text-lg mb-8 leading-relaxed">
            We’re not just in the business of repairs—we’re in the business of
            building trust. With a commitment to honesty, professionalism, and
            attention to detail, we strive for every job being done right the
            first time.
          </p>
          <p className="text-lg md:text-2xl leading-relaxed">
            We're proud to serve Johnson County and the surrounding area, and
            we look forward to helping you make your house feel more like
            home.
          </p>
        </div>
      </div>

      {/* Two-Column Section */}
      <div className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-12 items-center">
            {/* Column 1 */}
            <div className="text-center space-y-6">
              <p className="w-1/2 mx-auto text-lg leading-relaxed">
                Thank you for taking the time to visit my website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
